import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StatusPillComponent } from '@shared/components/general/status-pill/status-pill.component';
import { orderStatusNames, orderStatusNamesTooltips } from '@shared/constants';
import { StatusPillColorsEnum } from '@shared/enums';
import { OrderStatusEnum } from '@shared/enums/order-status.enum';
import { TooltipModule } from 'primeng/tooltip';
import { RetestStatusEnum } from 'src/app/features/orders-retest/orders-retest-list/_core/enums';

@Component({
    selector: 'app-order-status',
    standalone: true,
    imports: [TranslateModule, TooltipModule, StatusPillComponent],
    templateUrl: './order-status.component.html',
    styleUrls: [],
    host: { style: 'display: contents' },
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusComponent {
    readonly status = input.required<OrderStatusEnum | RetestStatusEnum>();
    readonly size = input<'large' | 'small'>('small');

    readonly statusTooltip = computed(() => orderStatusNamesTooltips[this.status()]);
    readonly statusName = computed(() => orderStatusNames[this.status()]);
    readonly statusColor = computed(() => {
        switch (this.status()) {
            case OrderStatusEnum.ACTION_REQUIRED:
                return StatusPillColorsEnum.RED;
            case OrderStatusEnum.COMPLETED:
                return StatusPillColorsEnum.GREEN;
            case OrderStatusEnum.IN_PROGRESS:
                return StatusPillColorsEnum.BLUE;
            case OrderStatusEnum.RECEIVED:
                return StatusPillColorsEnum.PURPLE;
            case OrderStatusEnum.CANCELED:
                return StatusPillColorsEnum.DARK_GRAY;
            case OrderStatusEnum.INCOMPLETE:
                return StatusPillColorsEnum.LIGHT_GRAY;
            case OrderStatusEnum.ORDER_SUBMITTED:
                return StatusPillColorsEnum.ORANGE;
            case OrderStatusEnum.PARTIALLY_COMPLETED:
                return StatusPillColorsEnum.YELLOW;
            case OrderStatusEnum.CANCELED_FROM_LIMS:
                return StatusPillColorsEnum.DARK_GRAY;
            default:
                return StatusPillColorsEnum.DARK_GRAY;
        }
    });
}
